<template>
  <v-form @submit.prevent="signUp" class="d-flex justify-center flex-column">
    <v-card-text class="d-flex flex-column align-center">
      <p style="max-width: 16rem" class="my-4 text-center">{{ $t('message.otpSentTo', { mobileNumber: otpPhoneNumber }) }}</p>
      <p class="primary--text text-center font-weight-bold mb-2" v-show="otpLockout">{{ $t('message.otpCodeResent', { lockOutTime: parsedLockoutTime }) }}</p>
      <div class="mb-4 d-flex">
        <OTPInput ref="otpInput" input-classes="otp-input" separator="" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-complete="handleOnComplete" />
      </div>
      <p class="error--text" v-show="errorMessage">
        {{ errorMessage }}
      </p>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn
        color="primary"
        class="mx-5 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles"
        type="button"
        @click="requestNewOTP"
        :loading="loading"
        :disabled="otpLockout"
      >
        {{ $t('button.resendOtp') }}
      </v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import OTPInput from '@bachdgvn/vue-otp-input'

import LeftArrow from '@/assets/icons/left-arrow-circle.svg'
import { mapActions, mapState } from 'vuex'
import { OTP_Type } from '@/constants/enums'
import { uiHelper } from '@/utils'

export default {
  components: { OTPInput, LeftArrow },

  props: {
    otpType: { type: String, default: 'REGISTER' }
  },

  data: () => ({
    loading: false,
    form: {
      otp: ''
    },
    otpLockoutTime: 60,
    errorMessage: ''
  }),

  methods: {
    ...mapActions('common', ['verifyOTP', 'resendOTP']),
    clearOTPInput() {
      this.$refs.otpInput.clearInput()
    },

    requestNewOTP() {
      this.clearOTPInput()
      this.errorMessage = ''
      this.loading = true
      this.resendOTP()
        .then(() => {
          this.otpLockoutTime = 60
        })
        .catch((err) => {
          this.errorMessage = 'Unknown error, please try again'
          if (err) {
            this.errorMessage = err.response.data.error_message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    async handleOnComplete(otp) {
      this.errorMessage = ''
      this.loading = true
      this.form.otp = otp
      await this.verifyOTP({
        ...this.form,
        type: OTP_Type[this.otpType]
      })
        .then(() => {
          this.$emit('next-step')
        })
        .catch((err) => {
          this.errorMessage = 'Unknown error, please try again'
          if (err) {
            this.errorMessage = err.error_message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  computed: {
    ...mapState('common', ['otpPhoneNumber']),
    otpLockout() {
      return this.otpLockoutTime > 0
    },
    parsedLockoutTime() {
      return `${uiHelper.padTime(Math.floor(this.otpLockoutTime / 60))}:${uiHelper.padTime(this.otpLockoutTime % 60)}`
    }
  },

  watch: {
    otpLockoutTime: {
      handler(val) {
        if (val > 0) {
          setTimeout(() => {
            this.otpLockoutTime--
          }, 1000)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .otp-input {
  width: 35px;
  height: 35px;
  padding: 5px;
  margin: 0 8px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }

  @media only screen and (min-width: 640px) {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
